import * as Yup from "yup";

export const MARKETPLACE_ITEM_VALIDATION = Yup.object({
  rule: Yup.string().trim().required("Select a capability").label("Capability"),
  name: Yup.string().trim().required().label("Name"),
  description: Yup.string().trim().required().label("Description"),
  kind: Yup.string().required().label("Kind"),
  monthlyAmount: Yup.number()
    .typeError("Price must be a number")
    .min(0, "Price cannot be negative")
    .required()
    .label("Price"),
  status: Yup.string().oneOf(["ACTIVE", "HIDDEN"]).required().label("Status"),
  unitValue: Yup.number()
    .nullable()
    .transform((v, o) => (o === "" || o === null || o === undefined ? null : v))
    .when("kind", {
      is: (val) => String(val).toUpperCase() === "LIMIT",
      then: (schema) =>
        schema
          .typeError("Unit value must be a number")
          .min(1, "Unit value must be at least 1")
          .required("Unit value is required"),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),
  quantityMin: Yup.number()
    .nullable()
    .transform((v, o) => (o === "" || o === null || o === undefined ? null : v))
    .when("kind", {
      is: (val) => String(val).toUpperCase() === "LIMIT",
      then: (schema) =>
        schema.typeError("Min must be a number").min(1).required("Min is required"),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),
  quantityMax: Yup.number()
    .nullable()
    .transform((v, o) => (o === "" || o === null || o === undefined ? null : v))
    .when("kind", {
      is: (val) => String(val).toUpperCase() === "LIMIT",
      then: (schema) =>
        schema
          .typeError("Max must be a number")
          .min(Yup.ref("quantityMin"), "Max must be ≥ min")
          .required("Max is required"),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),
  quantityStep: Yup.number()
    .nullable()
    .transform((v, o) => (o === "" || o === null || o === undefined ? null : v))
    .when("kind", {
      is: (val) => String(val).toUpperCase() === "LIMIT",
      then: (schema) =>
        schema.typeError("Step must be a number").min(1).required("Step is required"),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),
  eligiblePlanIds: Yup.array().of(Yup.string()),
  bundleRules: Yup.array().of(Yup.string()),
});

export const GRANT_ADDON_VALIDATION = Yup.object({
  organizationId: Yup.string().trim().required().label("Organization"),
  itemCode: Yup.string().trim().required().label("Add-on"),
  quantity: Yup.number()
    .nullable()
    .transform((v, o) => (o === "" || o === null || o === undefined ? null : v))
    .min(1, "Quantity must be at least 1")
    .label("Quantity"),
  reason: Yup.string().trim().required().label("Reason"),
});

export const UPDATE_QUANTITY_VALIDATION = Yup.object({
  quantity: Yup.number()
    .typeError("Quantity must be a number")
    .min(1)
    .required()
    .label("Quantity"),
  reason: Yup.string().trim().required().label("Reason"),
});

export const REVOKE_ADDON_VALIDATION = Yup.object({
  reason: Yup.string().trim().required().label("Reason"),
  atPeriodEnd: Yup.boolean().default(false),
});
